import { config } from '../../main/config';
import {
  ITable,
  ITableColumn,
  ITableSort,
  TableAction,
  ITableSearchTag,
  prepareColumns
} from '../../shared/ui/models/table';
import { ComponentType } from '../../shared/ui/models/component';

export class TradeTable implements ITable {
  static index = 1;

  id: string;
  parentId: string;
  type: ComponentType = ComponentType.Trade;
  actions: TableAction[] = [
    TableAction.SEARCH,
    TableAction.DOWNLOAD_CSV,
    TableAction.HIDDING_ROWS,
    TableAction.PINNING_ROWS,
    TableAction.LIMIT_TRADES
  ];
  columns: ITableColumn[] = [];
  sorting: ITableSort[];
  hiddenColumnNames: string[];
  hiddenRows: any[] = [];
  tags: ITableSearchTag[] = [];
  showHeadlines: boolean = true;
  showingHidden: boolean = false;
  filters = {};
  pinnedRows = [];
  externallyPaginated = true;
  cmpFunctions?: {[columnName: string]: (o1: any, o2: any) => number};
  
  constructor(parentId: string, customId?: string) {
    this.id = customId
      ? customId
      : new Date().getUTCMilliseconds().toString() + TradeTable.index++;
    this.parentId = parentId;
    this.columns = config.ui.tradeTable.columns.map(c => { return {...c}; });

    if (customId) {
      this.hiddenColumnNames = prepareColumns(config.ui.tradeTable, this.columns, true);
      this.sorting = config.ui.tradeTable.recentDefaultSorting;
    } else {
      this.hiddenColumnNames = prepareColumns(config.ui.tradeTable, this.columns, false);
      this.sorting = config.ui.tradeTable.defaultSorting;
    }

    this.cmpFunctions = {
      time: (o1, o2) => {
        return o1.timestamp - o2.timestamp;
      },
      date:  (o1, o2) => {
        return o1.timestamp - o2.timestamp;
      }
    }
  }
}
